if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function() {
  const timeRecharge = setTimeout(rechargeInit, 2000);

  function rechargeInit() {
    let div = document.querySelector(".rc-template__radio-group"); 

    if(div) {
      // Crea un nuevo elemento de texto
      let newText = document.createElement("p");
      newText.textContent = "Frequency";

      // Inserta el nuevo texto antes del div
      div.parentNode.insertBefore(newText, div);

      let newTextTwo = document.createElement("span");
      newTextTwo.className = "info-dilivery";
      newTextTwo.innerHTML = "*Modify, pause, or cancel any time <br>Never run out - delivered to your door each month";
      
      // Inserta el nuevo texto antes del div
      div.parentNode.appendChild(newTextTwo, div);

      let subsContent = document.querySelector(".subscription-radio .discount-label");
      let newTextSubs = document.createElement("span");

      newTextSubs.className = "info-subs";
      newTextSubs.innerHTML = "Save 15% for 3 months*";

      // Inserta el nuevo texto antes del div
      subsContent.parentNode?.appendChild(newTextSubs, subsContent);
    }

    const __purchaseWidget = document.querySelector('.rc-widget');
    if(__purchaseWidget) {
      const __purchaseOptions = __purchaseWidget.querySelectorAll('.rc-radio-group__options .rc-radio');
  
      if(__purchaseOptions) {
        Array.from(__purchaseOptions, (__option) => {
          __option?.addEventListener("click", function(e) {
            const __option = e.target.parentNode;
  
            if(__option?.classList.contains('onetime-radio')) {
              if(document.querySelector('.product-form__buttons button.product-form__submit > span')) {
                document.querySelector('.product-form__buttons button.product-form__submit > span').innerHTML = "Add to cart";
                document.querySelector('.price-compare-btn-product').style.display = "none";
                document.querySelector('.info-dilivery').style.display = "none";  
              }
            } else if(__option?.classList.contains('subscription-radio')) {
              var __price = __option.querySelector('.price-label')?.innerHTML;
              var __size = "(" + document.querySelector('input[name="Size"]')?.value + ")";
              document.querySelector('.price-compare-btn-product').style.display = "block";
              document.querySelector('.info-dilivery').style.display = "block";  
              if(document.querySelector('.product-form__buttons button.product-form__submit > span')) {
                document.querySelector('.product-form__buttons button.product-form__submit > span').innerHTML = "Subscribe Now -" + " " + __price + " " + __size;
              }
            }
          });
        });
      }
      document.querySelector('.rc-radio.subscription-radio')?.click();
    }
    clearTimeout(timeRecharge);
  }

  const itemsTabsActive = document.querySelectorAll('.content-tabs-info .item');
  const detailsBox = document.querySelector('.product__details-box');
  const __variantSelects = document.querySelector('variant-selects');
  const __subscriptionWidget = document.querySelector('.recharge-subscription-widget');
  const __stayAiSubscriptionWidget = document.querySelector('.stay-ai-subscription-widget');
  const __findInStoreBtn = document.querySelector('.find-store-btn-wrapper');
  const __addToCartCustom = document.querySelector('.content-atc-custom');

  function activateTab(item) {
    if (!item) return;

    itemsTabsActive?.forEach(i => {
      i?.classList.remove('active');
      i?.setAttribute('aria-selected', 'false');
      i?.setAttribute('tabindex', '-1');
    });

    item.classList.add('active');
    item.setAttribute('aria-selected', 'true');
    item.setAttribute('tabindex', '0');
    item.focus();

    const activeText = item?.textContent;
    if (activeText.includes('In Store')) {
      detailsBox.classList.add('is-in-store')
      if( __variantSelects) {
        __variantSelects.style.display = 'none';
      }
      if(__subscriptionWidget) {
        __subscriptionWidget.style.display = 'none';
      }
      if(__findInStoreBtn) {
        __findInStoreBtn.style.display = 'flex';
      }
      if(__addToCartCustom) {
        __addToCartCustom.style.display = 'none';
      }
    } else {
      detailsBox.classList.remove('is-in-store')
      if(__variantSelects) {
        __variantSelects.style.display = 'block';
      }
      if (__subscriptionWidget) {
        __subscriptionWidget.style.display = 'block';
      }
      if (__stayAiSubscriptionWidget && __subscriptionWidget) {
        __subscriptionWidget.style.display = 'block';
      }
      if(__findInStoreBtn) {
        __findInStoreBtn.style.display = 'none';
      }
      if (__addToCartCustom) {
        __addToCartCustom.style.display = 'flex';
      }
    }
  }

  itemsTabsActive?.forEach((item, index) => {
    item?.addEventListener('click', () => activateTab(item));

    item?.addEventListener('keydown', (e) => {
      const tabsArray = Array.from(itemsTabsActive);
      let targetIndex;

      switch (e.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          targetIndex = index === 0 ? tabsArray.length - 1 : index - 1;
          activateTab(tabsArray[targetIndex]);
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          targetIndex = index === tabsArray.length - 1 ? 0 : index + 1;
          activateTab(tabsArray[targetIndex]);
          break;
        case 'Home':
          e.preventDefault();
          activateTab(tabsArray[0]);
          break;
        case 'End':
          e.preventDefault();
          activateTab(tabsArray[tabsArray.length - 1]);
          break;
      }
    });
  });

  __findInStoreBtn?.addEventListener('click', () => {
    console.log('clicked find in store button')
  });

  const readMoreSelect = document.querySelectorAll('.custom-description-ingredients .read-more');
  readMoreSelect?.forEach(item => {
    item?.addEventListener('click', () => {
      // Remover la clase 'active' de todos los ítems
      readMoreSelect?.forEach(i => i.parentElement?.classList.remove('u-v-hide'));
      // Agregar la clase 'active' al ítem clicado
      item.parentElement?.classList.add('u-v-hide');
    });
  });
});